import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './EditJob.module.css';
import BubbleButton from '../../../components/UI/Buttons/BubbleButton/BubbleButton';
import FormOptionField from '../../../components/UI/UpdatedFormUI/FormOptionField/FormOptionField';
import FormSelectField from '../../../components/UI/UpdatedFormUI/FormSelectField/FormSelectField';
import { FaPlus } from "react-icons/fa6";

function AdditionalRequirements({ formik, activeSteps, setActiveSteps, saveAsDraftOnly, updateJobOnly, id, draftLoading, submitLoading, formik_values_status }) {
    const { t } = useTranslation();
    const [localDraftLoading, setLocalDraftLoading] = useState(false);
    const [localUpdateLoading, setLocalUpdateLoading] = useState(false);
    const [showVisaProvided, setShowVisaProvided] = useState(false);

    // Update the formik validation when nationalityRequirment changes
    useEffect(() => {
        if (formik.values.nationalityRequirment === 'Yes') {
            // Make nationality required
            formik.setFieldValue('nationalityRequired', true);
        } else {
            // Make nationality not required
            formik.setFieldValue('nationalityRequired', false);
            formik.setFieldValue('nationality', '');
        }
    }, [formik.values.nationalityRequirment]);

    // Check if visa provided should be shown based on nationality
    useEffect(() => {
        const gccNationalities = ['QA', 'AE', 'SA', 'BH', 'KW', 'OM'];
        // options={['QA', 'AE', 'SA', 'BH', 'KW', 'OM']}

        const shouldShowVisaProvided =
            (formik.values.nationalityRequirment === 'Yes' || formik.values.nationalityRequirment === 'No') &&
            formik.values.nationality &&
            !gccNationalities.includes(formik.values.nationality);

        setShowVisaProvided(shouldShowVisaProvided);
    }, [formik.values.nationalityRequirment, formik.values.nationality]);

    // Set default value for nationalityRequirment if not already set
    useEffect(() => {
        if (!formik.values.nationalityRequirment) {
            formik.setFieldValue('nationalityRequirment', 'Any');
        }
    }, []);

    const visaProvidedOptions = [
        { value: 'Yes', label: t('additional_requirment.Yes') },
        { value: 'No', label: t('additional_requirment.No') },
    ];

    const visaRequirment = [
        { value: 'Yes', label: t('additional_requirment.Yes') },
        { value: 'No', label: t('additional_requirment.No') },
    ];
    const nationalityRequirmentOption = [
        { value: 'Yes', label: t('additional_requirment.Yes') },
        { value: 'No', label: t('additional_requirment.Any', 'Any') },
    ];
    const licenseRequirmentOption = [
        { value: 'Yes', label: t('additional_requirment.Yes') },
        { value: 'No', label: t('additional_requirment.No') },
        { value: 'Preferred', label: t('additional_requirment.Preferred', 'Preferred') },
    ];
    const genderOptions = [
        { value: 'Any', label: t('additional_requirment.Any', 'Any') },
        { value: 'Male', label: t('additional_requirment.Male', 'Male') },
        { value: 'Female', label: t('additional_requirment.Female', 'Female') },
    ];

    // Check if job location is remote
    const isRemoteJob = formik.values.job_location === 'remote';
    // Check if job location is in-person or hybrid
    const isInPersonOrHybrid = formik.values.job_location === 'in_person' || formik.values.job_location === 'hybrid';

    return (
        <>
            <div className={styles.row} style={{ margin: '20px 0px 0px 0px' }}>
                <div className={styles.inputContainer}>
                    <FormSelectField
                        name="languages"
                        type="language"
                        placeholder={t('forms.language.select_language')}
                        label={t('forms.language.select_language')}
                        hasBorder
                        isMulti
                        onFormikChange={formik.handleChange}
                        value={formik.values.languages}
                        error={formik.touched.languages && formik.errors.languages}
                    />
                </div>

                <div className={styles.inputContainer}>
                    <FormOptionField
                        name="gender"
                        label={t('talents.gender')}
                        type="radio"
                        dark
                        options={genderOptions}
                        onChange={formik.handleChange}
                        value={formik.values.gender}
                        error={formik.touched.gender && formik.errors.gender}
                    />
                </div>
            </div>

            {/* {!isRemoteJob && ( */}
            <div className={`${styles.row} ${styles.gap50}`}>
                <div
                    className={styles.halfInputContainer}>
                    <FormOptionField
                        name="nationalityRequirment"
                        label={t('additional_requirment.Nationality_Requirement')}
                        type="radio"
                        dark
                        options={nationalityRequirmentOption}
                        onChange={formik.handleChange}
                        value={formik.values.nationalityRequirment}
                        error={formik.touched.nationalityRequirment && formik.errors.nationalityRequirment}
                    />
                </div>
                {formik.values.nationalityRequirment === 'Yes' &&
                    <div className={styles.inputContainer}>
                        <FormSelectField
                            name="nationality"
                            type="nationality"
                            hasBorder
                            label={t('general.UI.choose_required_nationality')}
                            placeholder={t('forms.welcome_employer.nationality')}
                            onFormikChange={(e) => {
                                formik.handleChange(e);
                                // Reset visa provided when nationality changes
                                if (formik.values.visaProvided === 'No') {
                                    formik.setFieldValue('visaProvided', 'Yes');
                                }
                            }}
                            value={formik.values.nationality}
                            error={formik.touched.nationality && formik.errors.nationality}
                        />
                    </div>
                }
                {!isRemoteJob && (
                    <>
                        {showVisaProvided && (
                            <>

                                <div className={styles.inputContainer}
                                >
                                    {/* Show Visa Provided based on nationality condition */}
                                    {showVisaProvided && (
                                        <div className={styles.row}>
                                            <FormOptionField
                                                name="visaProvided"
                                                label={t('additional_requirment.Visa_Provided', 'Visa Provided')}
                                                type="radio"
                                                dark
                                                options={visaProvidedOptions}
                                                onChange={formik.handleChange}
                                                value={formik.values.visaProvided || 'Yes'}
                                                error={formik.touched.visaProvided && formik.errors.visaProvided}
                                            />
                                        </div>
                                    )}

                                    {/* Display visa message when Visa Provided is No */}
                                    {showVisaProvided && formik.values.visaProvided === 'No' && (
                                        <div className={styles.row}>
                                            <div className={styles.visaMessage}>
                                                {t('additional_requirment.Visa_Message', 'Applicant must already have a valid visa to reside in a country.')}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                        {/* </div> */}

                        {/* {!isRemoteJob && ( */}
                        {!isInPersonOrHybrid && (
                            <div className={styles.inputContainer}>
                                <FormOptionField
                                    name="visaRequirment"
                                    label={t('additional_requirment.Visa_Requirment')}
                                    type="radio"
                                    dark
                                    options={visaRequirment}
                                    onChange={formik.handleChange}
                                    value={formik.values.visaRequirment}
                                    error={formik.touched.visaRequirment && formik.errors.visaRequirment}
                                />
                            </div>
                        )}
                    </>
                )}
            </div>

            {/* Only show license requirement if job is not remote */}
            {!isRemoteJob && (
                <>
                    <div className={styles.row}>
                        <div className={styles.inputContainer}>
                            <FormOptionField
                                name="licenseRequire"
                                label={t('additional_requirment.Driving_License_Requirement')}
                                type="radio"
                                dark
                                options={licenseRequirmentOption}
                                onChange={formik.handleChange}
                                value={formik.values.licenseRequire}
                                error={formik.touched.licenseRequire && formik.errors.licenseRequire}
                            />
                        </div>
                    </div>




                </>
            )}

            <div style={{ display: "flex", gap: 10 }}>
                <BubbleButton dark headerDarkButton
                    // type="submit"
                    onClick={() => {
                        if (formik.values.city && formik.values.country && formik.values.category && formik.values.title) {
                            setActiveSteps(activeSteps - 1)
                        }
                    }}
                    style={{ padding: '10px 20px' }}>{t('signupHeader.back')}</BubbleButton>

                <BubbleButton
                    dark
                    headerDarkButton
                    type="submit"
                    onClick={() => {
                        const hasValidLanguages = Array.isArray(formik.values.languages) && formik.values.languages.length > 0;

                        // Different validation logic based on job location type
                        if (isRemoteJob) {
                            // For remote jobs, only check language validation
                            if (hasValidLanguages) {
                                setActiveSteps(activeSteps + 1);
                            } else {
                                formik.setFieldError('languages', t('general.UI.required'));
                            }
                        } else {
                            // For non-remote jobs, check all required validations
                            const nationalityValid = formik.values.nationalityRequirment !== 'Yes' ||
                                (formik.values.nationality && formik.values.nationality.trim() !== '');

                            if (hasValidLanguages && nationalityValid) {
                                setActiveSteps(activeSteps + 1);
                            } else {
                                if (!hasValidLanguages) {
                                    formik.setFieldError('languages', t('general.UI.required'));
                                }

                                if (formik.values.nationalityRequirment === 'Yes' &&
                                    (!formik.values.nationality || formik.values.nationality.trim() === '')) {
                                    formik.setFieldError('nationality', t('general.UI.required'));
                                }
                            }
                        }
                    }}
                    style={{ padding: '10px 20px' }}
                >
                    {t('jobOverView.Next')}
                </BubbleButton>

                {(!id || (formik_values_status === 'draft')) && (
                    <BubbleButton
                        dark
                        headerDarkButton
                        onClick={async () => {
                            setLocalDraftLoading(true);
                            await saveAsDraftOnly();
                            setLocalDraftLoading(false);
                        }}
                        style={{ padding: '10px 20px', marginLeft: '10px' }}
                        disabled={localDraftLoading || localUpdateLoading || draftLoading || submitLoading}
                    >
                        {localDraftLoading ? (
                            <div className={styles.buttonLoader}>
                                <div className={styles.spinnerSmall}></div>
                                <span>{t('forms.login.processing')}</span>
                            </div>
                        ) : (
                            t('job.save_draft', 'Save Draft')
                        )}
                    </BubbleButton>
                )}

                {(id && formik_values_status !== 'draft') && (
                    <BubbleButton
                        dark
                        headerDarkButton
                        onClick={async () => {
                            setLocalUpdateLoading(true);
                            await updateJobOnly();
                            setLocalUpdateLoading(false);
                        }}
                        style={{ padding: '10px 20px', marginLeft: '10px' }}
                        disabled={localDraftLoading || localUpdateLoading || draftLoading || submitLoading}
                    >
                        {localUpdateLoading ? (
                            <div className={styles.buttonLoader}>
                                <div className={styles.spinnerSmall}></div>
                                <span>{t('forms.login.processing')}</span>
                            </div>
                        ) : (
                            t('job.update', 'Update')
                        )}
                    </BubbleButton>
                )}
            </div>
        </>
    );
}

export default AdditionalRequirements;
